// \src\router\config.tsx

import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import Promocoes from "@/pages/promocoes/page";
import Vendedores from "@/pages/vendedores/page";
import Produtos from "@/pages/produtos/page";
import ProdutoDetalhe from "@/pages/produto/page";
import Empresa from "@/pages/empresa/page";
import Noticias from "@/pages/noticias/page";
import Contato from "@/pages/contato/page";
import TrabalheConosco from "@/pages/trabalhe-conosco/page";
import Sorteio from "@/pages/sorteio/page";
import Outlet from "@/pages/outlet/page";
import AdminLogin from "@/pages/admin/login/page";
import AdminDashboard from "@/pages/admin/dashboard/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/promocoes", element: <Promocoes /> },
  { path: "/vendedores", element: <Vendedores /> },
  { path: "/produtos", element: <Produtos /> },
  { path: "/produto/:slug", element: <ProdutoDetalhe /> },
  { path: "/empresa", element: <Empresa /> },
  { path: "/noticias", element: <Noticias /> },
  { path: "/contato", element: <Contato /> },
  { path: "/trabalhe-conosco", element: <TrabalheConosco /> },
  { path: "/sorteio", element: <Sorteio /> },
  { path: "/outlet", element: <Outlet /> },
  { path: "/admin/login", element: <AdminLogin /> },
  { path: "/admin/dashboard", element: <AdminDashboard /> },
  { path: "*", element: <NotFound /> },
];

export default routes;